import React from "react";
import { Form } from "react-bootstrap";
import { DatePicker } from "../../component/DatePicker";

const DatePickerField = props => {
  const {
    label,
    className,
    isRequiredField,
    formData,
    onChange,
    isInceptionDate,
    issueInceptionDate
  } = props;
  return (
    <Form.Group className={`${className}`}>
      <Form.Label>
        {label} {isRequiredField ? <span className="required">*</span> : <></>}
      </Form.Label>
      <div className="form-field">
        <DatePicker
          isClearable={formData}
          value={formData}
          selected={formData}
          onChange={event => onChange(event)}
          className="issue-created-from meeting-date"
          disabled={isInceptionDate}
        />
      </div>
    </Form.Group>
  );
};
export default DatePickerField;
